import { memo } from 'react';
import PropTypes from 'prop-types';

import { Error, Running, Success, Warning } from 'basic-components/icons';

import { Case, Switch } from 'react-if';

const Icon = ({ isValidating = false, errorMessage = undefined, warningMessage = undefined }) => (
  <Switch>
    <Case condition={isValidating}>
      <div className="ncsv-creator__top__icon">
        <Running
            bgColor="blue-bright"
            color="white-base"
            height={48}
            width={48}
        />
      </div>
    </Case>
    <Case condition={errorMessage}>
      <div className="ncsv-creator__top__icon">
        <Error
            bgColor="red-base"
            color="white-base"
            height={48}
            width={48}
        />
      </div>
    </Case>
    <Case condition={warningMessage && !errorMessage}>
      <div className="ncsv-creator__top__icon">
        <Warning
            bgColor="orange-base"
            color="white-base"
            height={48}
            width={48}
        />
      </div>
    </Case>
    <Case condition={!isValidating && !warningMessage && !errorMessage}>
      <div className="ncsv-creator__top__icon">
        <Success
            bgColor="green-fresh"
            color="white-base"
            height={48}
            width={48}
        />
      </div>
    </Case>
  </Switch>
)

Icon.propTypes = {
  errorMessage: PropTypes.string,
  isValidating: PropTypes.bool,
  warningMessage: PropTypes.string,
}

export default memo(Icon)